import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActionConfirmationComponent } from "./action-confirmation/action-confirmation.component";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { PipesModule } from "../../pipes/pipes.module";

@NgModule({
  declarations: [ActionConfirmationComponent],
  imports: [
    CommonModule,
    FuseSharedModule,
    MatInputModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatDialogModule,
    PipesModule
  ]
})
export class ActionConfirmationModule {}
